__turbopack_context__.v({
  "link": "PHdM1G_link",
  "link--dark": "PHdM1G_link--dark",
  "link--disabled": "PHdM1G_link--disabled",
  "link--l": "PHdM1G_link--l",
  "link--m": "PHdM1G_link--m",
  "link--noUnderline": "PHdM1G_link--noUnderline",
  "link--s": "PHdM1G_link--s",
  "link--underline": "PHdM1G_link--underline",
  "link--xs": "PHdM1G_link--xs",
});
